<template>
  <div style="display:flex">
    <div class="state-label">Estado</div>
    <drop-down direction="down">
      <md-button
        slot="title"
        class="md-button md-round dropdown-toggle"
        :class="getClassState()"
        data-toggle="dropdown"
      >{{ getStatus() }}</md-button>
      <ul class="dropdown-menu">
        <li v-if="issue.status == 'Leída' || issue.status == 'Nueva'">
          <a href="#" @click="changeState('Pendiente de Datos')">Pendiente de Datos</a>
        </li>
        <li v-if="issue.status == 'Pendiente de Datos' || issue.status == 'Leída'">
          <a href="#" @click="changeState('En Proceso')">En Proceso</a>
        </li>
        <li v-if="issue.status != 'Nueva' && issue.status != 'Resuelta'">
          <a href="#" @click="changeState('Resuelta')">Resuelta</a>
        </li>
        <li v-if="issue.status == 'Resuelta'">
          <a href="#" @click="changeState('En Proceso')">En Proceso</a>
        </li>
      </ul>
    </drop-down>
  </div>
</template>
<script>
import { apiServer, staticServer, florette_web } from "@/globalVars.js";
import { reclamacionService } from "@/_services";

export default {
  name: "issue-status",
  components: {},
  props: {
    issue: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    getStatus() {
      switch (this.issue.status) {
        case "Nueva":
          return "Nueva";
        case "Leída":
          return "Leída";
        case "Pendiente de Datos":
          return "Pendiente de Datos";
        case "En Proceso":
          return "En Proceso";
        case "Resuelta":
          return "Resuelta";
        default:
          return "Leída";
      }
    },
    getClassState() {
      switch (this.issue.status) {
        case "New":
          return "md-warning";
        case "Leída":
          return "md-primary";
        case "En Proceso":
          return "md-danger";
        case "Resuelta":
          return "md-success";
        case "Pendiente de Datos":
          return "md-info";
        default:
          return "md-info";
      }
    },
    changeState(status) {
      reclamacionService.cambiarEstado(this.issue, status).then(
        (reclamacion) => {
          this.issue.status = status;
        },
        (error) => {
          swal({
            title: "¡Se ha producido un error!",
            type: "error",
            text: error,
            confirmButtonClass: "md-button md-error",
            buttonsStyling: false,
          });
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.state-label {
  font-size: 1.5em !important;
  padding-top: 15px;
  padding-right: 5px;
}
</style>


